import { fetcher } from '@commenda/utils';

import { TIndirectTaxBulkExportTransactionsRequest } from './types';

export async function bulkExportIndirectTaxTransactions(
  body: TIndirectTaxBulkExportTransactionsRequest,
  extend?: string
): Promise<{
  success: boolean;
  error?: string;
  data?: unknown;
}> {
  try {
    const url = extend
      ? `new-sales-tax/transactions/bulk/export?extend=${extend}`
      : 'new-sales-tax/transactions/bulk/export';

    const response = await fetcher(url, { method: 'POST', body }, undefined);

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to export transactions',
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to export transactions',
    };
  }
}
